import { render, staticRenderFns } from "./TestLoginPanel.vue?vue&type=template&id=0cb5efc0&scoped=true"
import script from "./TestLoginPanel.vue?vue&type=script&lang=js"
export * from "./TestLoginPanel.vue?vue&type=script&lang=js"
import style0 from "./TestLoginPanel.vue?vue&type=style&index=0&id=0cb5efc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb5efc0",
  null
  
)

export default component.exports